/**
 * This file was automatically generated and should not be edited.
 * Source: tokens.json from Figma variables (/sync-design-tokens) via scripts/generateTokensFromFigma.mjs
 */
/**
 * border-radius: 0px
 */
export const BORDER_RADIUS_0 = 'var(--border-radius-0)';
/**
 * border-radius: 2px
 */
export const BORDER_RADIUS_050 = 'var(--border-radius-050)';
/**
 * border-radius: 4px
 */
export const BORDER_RADIUS_100 = 'var(--border-radius-100)';
/**
 * border-radius: 6px
 */
export const BORDER_RADIUS_150 = 'var(--border-radius-150)';
/**
 * border-radius: 8px
 */
export const BORDER_RADIUS_200 = 'var(--border-radius-200)';
/**
 * border-radius: 10px
 */
export const BORDER_RADIUS_250 = 'var(--border-radius-250)';
/**
 * border-radius: 12px
 */
export const BORDER_RADIUS_300 = 'var(--border-radius-300)';
/**
 * border-radius: 16px
 */
export const BORDER_RADIUS_400 = 'var(--border-radius-400)';
/**
 * border-radius: 20px
 */
export const BORDER_RADIUS_450 = 'var(--border-radius-450)';
/**
 * border-radius: 24px
 */
export const BORDER_RADIUS_500 = 'var(--border-radius-500)';
/**
 * border-radius: 28px
 */
export const BORDER_RADIUS_550 = 'var(--border-radius-550)';
/**
 * border-radius: 32px
 */
export const BORDER_RADIUS_600 = 'var(--border-radius-600)';
/**
 * border-radius: 40px
 */
export const BORDER_RADIUS_700 = 'var(--border-radius-700)';
/**
 * border-radius: 9999px
 */
export const BORDER_RADIUS_FULL = 'var(--border-radius-full)';
